module.exports = __webpack_public_path__ + "static/media/apartment11.1274dbf4.jpg";